export const apiConfig = process.env.VUE_APP_API;
export const clientId = "6bebd6d4-e695-48a3-b754-b0319754f003";
export const tenantId = "d39b3018-688f-4d0d-9fce-8c3cb1169c21";
export const apiScope = "api://fb13e7ba-5f01-4529-a6be-d98c5379fd18";
